import React, { useEffect, useState } from "react";
import url from "../../services/url";
import { useHistory } from "react-router-dom";
import axios from "axios";
import useRole from "../../hooks/useRole";
import { checkPermission } from "../../utils/checkPermission";

function Register() {
  let history = useHistory();

  const [passwordShown, setPasswordShown] = useState(false);
  const [canViewRegister, setCanViewRegister] = useState(false);
  const [canRegisterUser, setCanRegisterUser] = useState(false);
  const userRole = useRole();

  const checkPermissions = async () => {
    try {
      const [viewAllowed, registerAllowed] = await Promise.all([
        checkPermission(userRole, "register_user_module", "view_register"),
        checkPermission(userRole, "register_user_module", "register_user"),
      ]);
      setCanViewRegister(viewAllowed);
      setCanRegisterUser(registerAllowed);
    } catch (error) {
      console.error("Permission check failed for Register User Module:", error);
    }
  };

  useEffect(() => {
    document.body.classList.add("bg-gradient-primary");
    if (userRole) {
      checkPermissions();
    }
  }, [userRole]);

  function onClickRegister(event) {
    event.preventDefault();
    const name = document.querySelector("#name").value;
    const email = document.querySelector("#email").value;
    const password = document.querySelector("#password").value;

    axios
      .post(
        url("user/register"),
        { name, email, password },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user.token")}`,
          },
        }
      )
      .then((res) => {
        history.push("/");
      });
  }


  // Password toggle handler
  const togglePassword = () => {
    // When the handler is invoked
    // inverse the boolean state of passwordShown
    setPasswordShown(!passwordShown);
  };

  if (!canViewRegister) {
    return <div></div>;
  }

  return (
    <div className="container">
      { <div className="row justify-content-center">
        <div className="col-xl-10 col-lg-12 col-md-9">
          <div className="card o-hidden border-0 shadow-lg my-5">
            <div className="card-body p-0">
              <div className="row">
                <div className="col-lg-6 d-none d-lg-block bg-login-image"></div>
                <div className="col-lg-6">
                  <div className="p-5">
                    <div className="text-center">
                      <h1 className="h4 text-gray-900 mb-4">
                        Register New User
                      </h1>
                    </div>
                    <div className="user">
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control rounded-input  form-control-user"
                          id="name"
                          placeholder="Name"
                        />
                      </div>
                      <div className="form-group">
                        <input
                          type="email"
                          className="form-control rounded-input form-control-user"
                          id="email"
                          placeholder="Email Address"
                        />
                      </div>
                      <div className="form-group  form-control-user position-relative">
                        <input
                          className="rounded-input form-control "
                          style={{ outline: "none" }}
                          //type="password"
                          type={passwordShown ? "text" : "password"}
                          //className="form-control form-control-user"
                          id="password"
                          placeholder="Password"
                        />
                        <span
                          className="inputPassword"
                          onClick={togglePassword}
                        >
                          {passwordShown ? (
                            <i className="fas fa-eye"></i>
                          ) : (
                            <i className="fas fa-eye-slash"></i>
                          )}
                        </span>
                      </div>

                      {canRegisterUser && (
                        <button
                          className="btn rounded-pill py-btn btn-primary btn-user btn-block"
                          onClick={onClickRegister}
                        >
                          Register
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>}
    </div>
  );
}

export default Register;
